export default [
  {
    //行程卡列表
    path: '/travelCardHome',
    component: resolve => require(['@/pages/travelCard/travelCardHome.vue'], resolve),
    meta: { title: "旅行卡" },
  },
  {
    //购买行程卡表单
    path: '/travelCardOrder/:id',
    component: resolve => require(['@/pages/travelCard/travelCardOrder.vue'], resolve),
    meta: { title: "填订单-核对支付" },
  },
  {
    //行程卡订单详情
    path: '/travelCardOrderDetails/:id',
    component: resolve => require(['@/pages/travelCard/travelCardOrderDetails.vue'], resolve),
    meta: { title: "订单详情" },
  },
  {
    //旅行卡使用明细
    path: '/travelCardUseInfo/:id',
    component: resolve => require(['@/pages/travelCard/travelCardUseInfo.vue'], resolve),
    meta: { title: "旅行卡" },
  },
  {
    //旅行卡支付页面
    path: '/payCard',
    component: resolve => require(['@/pages/travelCard/payCard.vue'], resolve),
    meta: { title: "旅行卡" },
  },
]


// WEBPACK FOOTER //
// ./src/router/modules/travelCard.js